// vue路由
import Vue from 'vue';
import Router from 'vue-router';
// 搜了宝 签到积分系统
const index = () => import('@/page/integral/index');
const sign = () => import('@/page/integral/sign');
const signInfo = () => import('@/page/integral/sign-info');
const userShare = () => import('@/page/integral/user-share');
const newUserOdr = () => import('@/page/integral/new-user-odr');
const article = () => import('@/page/integral/article');



// const lotteryResults = () => import('@/page/annualMeeting/lottery-results');
// const award = () => import('@/page/annualMeeting/award');
Vue.use(Router)

let router = new Router({
	// mode: 'history',
	mode: 'hash',
  routes: [
    { 
      path: '/',
      name: 'index',
      component: index
    },
    { 
      path: '/sign',
      name: 'sign',
      component: sign
    },
    { 
      path: '/sign-info',
      name: 'signInfo',
      component: signInfo
    },
    { 
      path: '/userShare',
      name: 'userShare',
      component: userShare
    },
    { 
      path: '/newUserOdr',
      name: 'newUserOdr',
      component: newUserOdr
    },
    { 
      path: '/article',
      name: 'article',
      component: article
    }
    // { 
    //   path: '/',
    //   name: 'lotteryResults',
    //   component: lotteryResults
    // },
    // { 
    //   path: '/award',
    //   name: 'award',
    //   component: award
    // }
  ]
})
//路由拦截器
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    // sessionStorage.removeItem('user');
    localStorage.removeItem('user');
  }
  next();
  // console.log('路由拦截');
  // token
  // let token = localStorage.getItem("token");
  // if (!token && to.token != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
  //用户信息
  // let user = JSON.parse(sessionStorage.getItem('user'));
  // if (!user && to.path != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index-signSystem.js